export default {"src":"/_next/static/media/icon_footer_leagues.8f584b57.svg","height":30,"width":37,"blurWidth":0,"blurHeight":0};